import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import qs from 'qs'
import Icon from '../../components/misc/Icons'
import { getAuthFlowEvent, verifyMobileSignin } from '../../actions/session'
import getErrorMessageForRequest from '../../utils/getErrorMessageForRequest'

class VerifyMobileSigninContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: 'confirm', // 'confirm' | 'loading' | 'success' | 'brokenLink' | 'error'
      errorMessage: '',
      authFlowEvent: null,
      code: null,
      eventInfo: null,
    }
    this.handleConfirm = this.handleConfirm.bind(this)
  }

  componentDidMount() {
    const { location, getAuthFlowEvent } = this.props
    const params = qs.parse(location.search.slice(1))
    const { authFlowEvent, code } = params

    if (!authFlowEvent || !code) {
      this.setState({ status: 'brokenLink' })
      return
    }

    this.setState({ authFlowEvent, code })

    getAuthFlowEvent(authFlowEvent, code)
      .then((eventInfo) => {
        // eslint-disable-next-line no-console
        console.log('getAuthFlowEvent response:', eventInfo)
        this.setState({ eventInfo })
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('getAuthFlowEvent error:', err)
      })
  }

  handleConfirm() {
    const { verifyMobileSignin } = this.props
    const { authFlowEvent, code } = this.state

    this.setState({ status: 'loading' })

    verifyMobileSignin(authFlowEvent, code)
      .then(() => {
        this.setState({ status: 'success' })
      })
      .catch((err) => {
        const message = getErrorMessageForRequest({
          requestName: 'verifyMobileSignin',
          response: err.response,
        })
        this.setState({ status: 'error', errorMessage: message })
      })
  }

  render() {
    const { status, errorMessage, eventInfo } = this.state

    return (
      <DocumentTitle title='Plickers - Verify Mobile Sign-In'>
        <div className='verifyMobileSigninPage'>
          <div className='verifyMobileSigninPage-card marketing'>
            <div className='verifyMobileSigninPage-logo'>
              <Icon name='logo-full' />
            </div>
            <div className='verifyMobileSigninPage-divider' />

            {status === 'confirm' && (
              <React.Fragment>
                <div className='verifyMobileSigninPage-title'>
                  Was this you?
                </div>
                <div className='verifyMobileSigninPage-message'>
                  Someone is trying to sign in to Plickers on a mobile device.
                  If this was you, confirm below.
                </div>
                {eventInfo && eventInfo.requestInfo && (
                  <div className='verifyMobileSigninPage-requestInfo'>
                    <div className='verifyMobileSigninPage-requestInfo-title'>
                      Sign-In Details
                    </div>
                    <table className='verifyMobileSigninPage-requestInfo-table'>
                      <tbody>
                        {eventInfo.requestInfo.platform && (
                          <tr>
                            <td className='verifyMobileSigninPage-requestInfo-label'>OS</td>
                            <td className='verifyMobileSigninPage-requestInfo-value'>{eventInfo.requestInfo.platform}</td>
                          </tr>
                        )}
                        {eventInfo.requestInfo.country && (
                          <tr>
                            <td className='verifyMobileSigninPage-requestInfo-label'>Country</td>
                            <td className='verifyMobileSigninPage-requestInfo-value'>{eventInfo.requestInfo.country}</td>
                          </tr>
                        )}
                        {eventInfo.requestInfo.region && (
                          <tr>
                            <td className='verifyMobileSigninPage-requestInfo-label'>Region</td>
                            <td className='verifyMobileSigninPage-requestInfo-value'>{eventInfo.requestInfo.region}</td>
                          </tr>
                        )}
                        {eventInfo.requestInfo.city && (
                          <tr>
                            <td className='verifyMobileSigninPage-requestInfo-label'>City</td>
                            <td className='verifyMobileSigninPage-requestInfo-value'>{eventInfo.requestInfo.city}</td>
                          </tr>
                        )}
                        {eventInfo.requestInfo.ip && (
                          <tr>
                            <td className='verifyMobileSigninPage-requestInfo-label'>IP Address</td>
                            <td className='verifyMobileSigninPage-requestInfo-value'>{eventInfo.requestInfo.ip}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
                <button
                  type='button'
                  className='verifyMobileSigninPage-confirmBtn'
                  onClick={this.handleConfirm}
                >
                  Yes, it was me
                </button>
                <div className='verifyMobileSigninPage-notMeMessage'>
                  If you didn't attempt this sign-in, someone may have your
                  Plickers password. We recommend changing your password to
                  keep your account secure.
                </div>
              </React.Fragment>
            )}

            {status === 'loading' && (
              <div className='verifyMobileSigninPage-title verifyMobileSigninPage-title--loading'>
                Verifying...
              </div>
            )}

            {status === 'success' && (
              <React.Fragment>
                <div className='verifyMobileSigninPage-checkIcon'>
                  <Icon name='check-circle' />
                </div>
                <div className='verifyMobileSigninPage-title'>
                  Identity Verified
                </div>
                <div className='verifyMobileSigninPage-message'>
                  Thanks for verifying your identity. Please try signing in again on the mobile app.
                </div>
              </React.Fragment>
            )}

            {(status === 'brokenLink' || status === 'error') && (
              <React.Fragment>
                <div className='verifyMobileSigninPage-title verifyMobileSigninPage-title--error'>
                  {status === 'brokenLink' ? 'Invalid Link' : 'Verification Failed'}
                </div>
                <div className='verifyMobileSigninPage-message'>
                  {status === 'brokenLink' ?
                    'This link appears to be broken or incomplete. Please make sure you have the correct link.' :
                    errorMessage}
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default withRouter(connect(
  () => ({}),
  { getAuthFlowEvent, verifyMobileSignin },
)(VerifyMobileSigninContainer))
